import { render, staticRenderFns } from "./daochu.vue?vue&type=template&id=4b7d43f9&scoped=true"
import script from "./_daochu.js?vue&type=script&lang=js&external"
export * from "./_daochu.js?vue&type=script&lang=js&external"
import style0 from "./_daochu.scss?vue&type=style&index=0&id=4b7d43f9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d43f9",
  null
  
)

export default component.exports